/**
 * Product accordion: only one collapsible tab open at a time within each ProductInfo container.
 * Targets .product__accordion.accordion.quick-add-hidden details (Tip, What results..., Why Subscribe, etc.).
 */
(function () {
  function initProductAccordion(container) {
    var detailsList = container.querySelectorAll('.product__accordion.accordion.quick-add-hidden details');
    if (detailsList.length <= 1) return;
    detailsList.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!this.hasAttribute('open')) return;
        detailsList.forEach(function (other) {
          if (other !== details) {
            other.removeAttribute('open');
            var summary = other.querySelector('summary');
            if (summary) summary.setAttribute('aria-expanded', 'false');
          }
        });
      });
    });
  }

  function run() {
    var containers = document.querySelectorAll('[id^="ProductInfo-"]');
    containers.forEach(initProductAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
